function unorderedArgs(url, params) {
    return {
        test: function (requestedUrl) {
            // check the base url (i.g. /some/url)
            if (requestedUrl.indexOf(url) !== 0)
                return false;
            var urlEncodedArgs = requestedUrl.substr(url.length);
            return angular.equals(params, parseUrlEncoded(urlEncodedArgs));
        }
    };
}
/**
 * This module is used to simulate backend server for this demo application.
 */
angular.module('content-mocks', ['ngMockE2E'])
    .run(function ($httpBackend) {
    var authCount = 0; // Hack to test that authentication works after general login (could implement a time-out later)
    var authorized = false;
    //    $httpBackend.whenGET(unorderedArgs('servlets/auth/login', {name: 'smith', orderBy: 
    //'age:asc', page: 1}).respond(function(method, url, data) {
    //    $httpBackend.whenPOST('servlets/auth/login&username=*').respond(function(method, url, data) {
    $httpBackend.whenPOST('servlets/login').respond(function (method, url, data) {
        //logger.debug("Backend HERE(" +method+","+url+","+data+")");
        authorized = true;
        return [200];
    });
    $httpBackend.whenPOST('auth/logout').respond(function (method, url, data) {
        authorized = false;
        return [200];
    });
    $httpBackend.whenPOST('data/public').respond(function (method, url, data) {
        return [200, 'I have received and processed your data [' + data + '].'];
    });
    $httpBackend.whenPOST('data/protected').respond(function (method, url, data) {
        return authorized ? [200, 'This is confidential [' + data + '].'] : [401];
    });
    //otherwise
    $httpBackend.whenGET('patients/').respond(function (method, url, data) {
        if (++authCount < 2)
            authorized = false;
        //    	console.log("Mock HERE: authCount = " + authCount);
        data = [
            {
                "firstname": "Mock",
                "lastname": "Number 1",
                "email": "john@doe.com",
                "mobile": "252-5555"
            },
            {
                "firstname": "Mock",
                "lastname": "Number 2",
                "email": "john@doe.com",
                "mobile": "252-4444"
            }
        ];
        //return [200, data];
        return authorized ? [200, data] : [401];
    });
    $httpBackend.whenGET(/.*/).passThrough();
});
//# sourceMappingURL=content-mocks.js.map